// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"oK-z","carouselContainer":"pK-z"};